import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { FolderSvg } from './FolderSvg'

export const EaFolderIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={FolderSvg} {...props} />
)
